<template>
    <div class="content">
        <div class="content-select">
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="select-title">
                        <div class="title-img">
                            <img src="@/assets/appraisal/select-icon.png" alt="">
                        </div>
                        <div class="title-info">
                            <span>培训机构数据</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
       <div class="content-header">
        <myTableSearch :isOperate="true" :operateWidth="376" :formData="formData" :tableLabel="tableLabel"
				:queryFn="queryFn" :queryParams="queryParams" @successQuery="successQuery" :searchColLg="6" ref="tableRef" dataRow="rows" >
			<template slot="creditLevel" slot-scope="scope">
				<img 
					v-if="getIntegrityGradeIcon(scope.row.creditLevel)" 
					:src="getIntegrityGradeIconSrc(scope.row.creditLevel)"
					style="width: 20px; height: 20px;"
					alt=""
				/>
				<span v-else>-</span>
			</template>
				<template slot="operate" slot-scope="scope">
					<el-button type="text" @click="handleView(scope.row)">详情</el-button>
                    <el-button type="text" @click="handleTeam(scope.row)">管理团队</el-button>
                    <el-button type="text" @click="handleTeachingPoint(scope.row)">教学点</el-button>
                    <el-button type="text" @click="handleTrainingProgram(scope.row)">培训项目</el-button>
                    <el-button type="text" @click="handleClass(scope.row)">培训班</el-button>
				</template>
			</myTableSearch>
       </div>
       <TrainingInstitutionDetail ref="trainingInstitutionDetailRef"  :isDialog="isDialog" :title="Title"  :institutionId="InstitutionId" />
       <training-institutionTeam ref="trainingInstitutionTeamRef" :isDialog="isDialog" :title="Title" :institutionId="InstitutionId" />
       <training-institutionTeachingPoint ref="trainingInstitutionTeachingPointRef" :isDialog="isDialog" :title="Title" :institutionId="InstitutionId" />
       <training-institutionTrainingProgram ref="trainingInstitutionTrainingProgramRef" :isDialog="isDialog" :title="Title" :institutionId="InstitutionId" />
    </div>
</template>

<script>
import '@/assets/css/base.css'
import {getTrainingInstitutionList} from '@/api/training'
import { getListByDictType } from '@/api/sys/dictData'
import TrainingInstitutionDetail from './component/detail.vue'
import TrainingInstitutionTeam from './component/team.vue'
import TrainingInstitutionTeachingPoint from './component/teachingPoint.vue'
import TrainingInstitutionTrainingProgram from './component/trainingProgram.vue'


export default {
    name: 'PolicyList',
    components: {
        TrainingInstitutionDetail,
        TrainingInstitutionTeam,
        TrainingInstitutionTeachingPoint,
        TrainingInstitutionTrainingProgram
	},
    data() {
        return {
			currentPage: 1,
			isDialog: false,
            Title: '',
            InstitutionId:"",
			queryParams: {
				pageNum: 1,
				pageSize: 10,
				pageSizes: [10, 20, 50]
			},
			formData: [
                {
                    label: '统一社会信用代码',
                    type: 'input',
                    key: 'institutionId',
                    colLg: 6,
                    placeholder: '统一社会信用代码'
                },
				{
					label: '机构名称',
					type: 'input',
					key: 'institutionName',
					colLg: 6,
					placeholder: '机构名称'
				},
				{
					label: '诚信等级',
					type: 'select',
					key: 'creditLevel',
					colLg: 6,
					data: []
				},
                {
                    label: '许可证号',
                    type: 'input',
                    key: 'licenseNumber',
                    colLg: 6,
                    placeholder: '许可证号'
                },
				{
					label: '许可证到期日',
					type: 'date',
					key: 'licenseExpiryDate',
					colLg: 6,
					format: 'yyyy-MM-dd'
				}
			],
			tableLabel: [
                {
                    prop: 'institutionId',
                    label: '统一社会信用代码',
                    minWidth: 150
                },
				{
					prop: 'institutionName',
					label: '机构名称',
					minWidth: 150
				},
				{
					prop: 'districtName',
					label: '所属区域',
					minWidth: 200
				},
                {
                    prop: 'createByName',
                    label:'联系人',
                    minWidth: 150
                },
				{
					prop: 'contactPhone',
					label: '联系电话',
					width: 150
				},
				{
					prop: 'creditLevel',
					label: '诚信等级',
					width: 120
				},
				{
					prop: 'licenseNumber',
					label: '许可证号',
					minWidth: 150
				},
				{
					prop: 'licenseExpiryDate',
					label: '许可证有效日期',
					minWidth: 200
				}
			],
		}
    },
    mounted() {
        this.loadIntegrityGradeData()
    },
    methods: {
		// 获取列表数据
		queryFn(queryParams) {
			return getTrainingInstitutionList(queryParams)
		},
		// 获取诚信等级字典
		async loadIntegrityGradeData() {
			const res = await getListByDictType('cultivate_institution_integrity_grade')
			if (res && res.code === 200 && res.data) {
				this.updateFormDataWithIntegrityGrade(res.data)
			}
		},
		// 更新诚信等级下拉选项
		updateFormDataWithIntegrityGrade(gradeData) {
			if (!gradeData) return

			const gradeIndex = this.formData.findIndex(item => item.key === 'creditLevel')
			if (gradeIndex !== -1) {
				// 在数据开头添加"全部"选项
				const dataWithAll = [
					{
						dictLabel: '全部',
						dictValue: ''
					},
					...gradeData
				]
				this.$set(this.formData[gradeIndex], 'data', dataWithAll)
				this.$set(this.formData[gradeIndex], 'screen', (value) => {
					if (!value) return ''
					const selectedItem = dataWithAll.find(item => item.dictValue === value)
					return selectedItem ? selectedItem.dictLabel : value
				})
			}
		},
		// 上一页
		handlePrevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
				this.queryParams.pageNum = this.currentPage;
				this.$refs.tableRef && this.$refs.tableRef.handleSearch();
			}
		},
		// 下一页
		handleNextPage() {
			this.currentPage++;
			this.queryParams.pageNum = this.currentPage;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		// 更新总数
		successQuery(e) {
			this.syrkNum = e.total;
		},
		// 根据诚信等级名称获取对应的图标文件名
		getIntegrityGradeIcon(gradeName) {
			if (!gradeName) return ''
			const upperName = String(gradeName).toUpperCase()
			if (upperName.includes('A')) {
				return 'rankA'
			} else if (upperName.includes('B')) {
				return 'rankB'
			} else if (upperName.includes('C')) {
				return 'rankC'
			}
			return ''
		},
		// 获取图标路径
		getIntegrityGradeIconSrc(gradeName) {
			const iconName = this.getIntegrityGradeIcon(gradeName)
			if (!iconName) return ''
			return require(`@/assets/images/custom-icons/${iconName}.svg`)
		},

        //查看详情
        handleView(row) {
            this.Title = `${row.institutionName}-机构基本信息`
            this.InstitutionId = row.institutionId
            this.$refs.trainingInstitutionDetailRef.openDialog(row)
        },

        //管理团队
        handleTeam(row) {
            this.Title = `${row.institutionName}-机构管理团队`
            this.InstitutionId = row.institutionId
            this.$refs.trainingInstitutionTeamRef.openDialog(row)
        },

        //教学点
        handleTeachingPoint(row) {
            this.Title = `${row.institutionName}-教学点`
            this.InstitutionId = row.institutionId
            this.$refs.trainingInstitutionTeachingPointRef.openDialog(row)
        },

        //培训项目
        handleTrainingProgram(row) {
            this.Title = `${row.institutionName}-机构培训项目信息`
            this.InstitutionId = row.institutionId
            this.$refs.trainingInstitutionTrainingProgramRef.openDialog(row)
        },

        //培训班
        handleClass(row) {
            this.Title = `${row.institutionName}-机构培训班信息`
            this.InstitutionId = row.institutionId
            console.log(this.$route.path,'当前路由路径')
            this.$router.push({
                path: '/employment/training/organ/institutionClass',
                query: {
                    title: this.Title,
                    institutionId: row.institutionId
                }
            })
        }
	},
}
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    height: auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding-bottom: 24px;

    &-select{
        height: 50px;
        .select-title{
            height: 46px;
            background: url('~@/assets/appraisal/selectBg.png') no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            gap: 12px;
            padding-left: 16px;
            .title-img{
                width: 18px;
                height: 18px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .title-info{
                color: var(--vt-c-black-mute-soft);
                font-size: 16px;
                font-weight: 700;
            }
        }
        .select-serch{
            margin-top: 12px;
            display: flex;
            align-items: center;
            gap: 8px;
            .serch-hint{
                color: var(--vt-c-black-mute-soft);
                font-size: 14px;
                font-weight: 400;
            }
            .serch-info{
                height: 28px;
                display: flex;
                align-items: center;
                gap: 12px;
                .info-item{
                    width: 120px;
                    height: 28px;
                    text-align: center;
                    line-height: 28px;
                    background: var(--vt-c-blue-mute);
                    color: var(--vt-c-blue);
                    border-radius: 2px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    
                    &:hover {
                        opacity: 0.8;
                    }
                    
                    &.active {
                        background: var(--vt-c-blue);
                        color: var(--vt-c-white);
                    }
                    
                    &:active:not(.active) {
                        transform: scale(0.98);
                    }
                }
            }
        }
    }
    &-header{
        margin-top: 16px;
        padding: 0 24px;
        
        /deep/.myTableSearch {
            padding: 0;
        }
    }
}

.link-text {
    color: #409eff;
    text-decoration: none;
    cursor: pointer;
    
    &:hover {
        text-decoration: underline;
    }
}

.toolbar-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;

    .toolbar-icon {
        width: 24px;
        height: 24px;
    }

    .add-icon {
        width: 20px;
        height: 20px;
        margin-right: 6px;
    }

    .toolbar-left {
        display: flex;
        align-items: center;
        gap: 12px;
		.tool-btn {
			width: 36px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px solid #dcdfe6;
			cursor: pointer;
			transition: all 0.2s;
			background-color: #FCFCFCFF;
		}
        .list-title {
            font-size: 14px;
            font-weight: 400;
            color:var(--vt-c-blue-soft);
        }
    }

    .toolbar-right {
        display: flex;
        align-items: center;
        gap: 12px;

        .import-upload {
            display: inline-block;
            
            /deep/.el-upload {
                display: inline-block;
            }
        }

        .el-button {
            height: 36px;
            padding: 0 16px;
        }
    }
}
</style>